// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Header
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

if ($('.cover').length > 0) {
  var header = document.querySelector('.header');
  var headerHeadroom = new Headroom(header, {
    offset: 0,
    tolerance: 0,
  });
  headerHeadroom.init();
}

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Mobile navigation
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

function openMobileNavigation() {
  $('.mobile-navigation').addClass('is-visible');
  $('.js-toggle-mobile-navigation').text('Sluiten');
}

function closeMobileNavigation() {
  $('.mobile-navigation').removeClass('is-visible');
  $('.js-toggle-mobile-navigation').text('Menu');
}

$('.js-toggle-mobile-navigation').click(function(e) {
  if ($('.mobile-navigation').hasClass('is-visible')) {
    closeMobileNavigation();
  } else {
    openMobileNavigation();
  }

  e.preventDefault();
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Product detail carousel
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

var $productDetailCarousel = $('.product__carousel__inner').flickity({
  draggable: true,
  wrapAround: true,
  prevNextButtons: false,
  pageDots: false,
});

$('.product__carousel__inner').on('change.flickity', function(event, index) {
  $(this)
    .next()
    .find('.product__carousel__options__active-slide')
    .text(index + 1);
});

$('.product__carousel__options__button--previous').click(function(e) {
  $productDetailCarousel.flickity('previous');
  e.preventDefault();
});

$('.product__carousel__options__button--next').click(function(e) {
  $productDetailCarousel.flickity('next');
  e.preventDefault();
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Product carousel
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('.product-carousel').each(function () {
  var amountOfSlides = $(this).find('.product-carousel__item').length;
  if (amountOfSlides < 4) {
    $(this).flickity({
      prevNextButtons: true,
      pageDots: false,
      wrapAround: false,
      cellAlign: 'center',
      initialIndex: 1,
      imagesLoaded: true,
      draggable: false,
    });
  } else {
    $(this).flickity({
      prevNextButtons: true,
      pageDots: true,
      wrapAround: true,
      imagesLoaded: true,
    });
  }
  
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Blog carousel
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('.blog-carousel').flickity({
  prevNextButtons: false,
  pageDots: true,
  wrapAround: true,
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Explore modal items
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

function closeExploreModalItems() {
  $('.explore-modal__item__button--toggle').removeClass('is-active');
  $('.explore-modal .link-list').addClass('is-hidden');
}

$('.explore-modal__item__button--toggle').click(function(e) {
  if ($(this).hasClass('is-active')) {
    closeExploreModalItems();
  } else {
    closeExploreModalItems();
    $(this)
      .addClass('is-active')
      .next()
      .removeClass('is-hidden');
  }

  e.preventDefault();
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Modal
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

function scrollToTop() {
  $(window).scrollTo($('body'), {
    duration: 300,
    easing: 'swing',
  });
}

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Explore modal
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

function openExploreModal() {
  if ($(window).width() < 1024) {
    closeMobileNavigation();
  }

  closeExploreModal();
  closeSearchModal();
  closeSecondaryNavigation();

  scrollToTop();

  closeExploreModalItems();
  $('.explore-modal').removeClass('is-hidden');
  $('.header').addClass('has-border');
}

function closeExploreModal() {
  $('.explore-modal').addClass('is-hidden');
  $('.header').removeClass('has-border');
}

$('.js-open-explore-modal').click(function(e) {
  if (!$('.explore-modal').hasClass('is-hidden')) {
    if ($(window).scrollTop() < 100) {
      closeExploreModal();
    } else {
      scrollToTop();
    }
  } else {
    openExploreModal();
  }

  e.stopPropagation();
  e.preventDefault();
});

$('.explore-modal').click(function(e) {
  e.stopPropagation();
});

$('body').click(function() {
  //closeExploreModal();
});

// Close explore modal when pressing 'esc'
$(document).on('keyup', function(evt) {
  if (evt.keyCode == 27) {
    //closeExploreModal();
  }
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Search modal
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

function openSearchModal() {
  if ($(window).width() < 1024) {
    closeMobileNavigation();
  }

  closeExploreModal();
  closeSearchModal();
  closeSecondaryNavigation();

  scrollToTop();

  $('.search-modal')
    .removeClass('is-hidden')
    .find('.search-modal__field')
    .focus();
  $('.header').addClass('has-border');
}

function closeSearchModal() {
  $('.search-modal').addClass('is-hidden');
  $('.header').removeClass('has-border');
}

$('.js-open-search-modal').click(function(e) {
  if (!$('.search-modal').hasClass('is-hidden')) {
    if ($(window).scrollTop() < 100) {
      closeSearchModal();
    } else {
      scrollToTop();
    }
  } else {
    openSearchModal();
  }

  e.stopPropagation();
  e.preventDefault();
});

$('.search-modal').click(function(e) {
  e.stopPropagation();
});

$('body').click(function() {
  closeSearchModal();
});

// Close search modal when pressing 'esc'
$(document).on('keyup', function(evt) {
  if (evt.keyCode == 27) {
    closeSearchModal();
  }
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Secondary navigation
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

function openSecondaryNavigation() {
  closeExploreModal();
  closeSearchModal();
  closeSecondaryNavigation();

  scrollToTop();

  $('.secondary-navigation').removeClass('is-hidden');
  $('.header').addClass('has-border');
}

function closeSecondaryNavigation() {
  $('.secondary-navigation').addClass('is-hidden');
  $('.header').removeClass('has-border');
}

$('.js-open-secondary-navigation').click(function(e) {
  if (!$('.secondary-navigation').hasClass('is-hidden')) {
    if ($(window).scrollTop() < 100) {
      closeSecondaryNavigation();
    } else {
      scrollToTop();
    }
  } else {
    openSecondaryNavigation();
  }

  e.stopPropagation();
  e.preventDefault();
});

$('.secondary-navigation').click(function(e) {
  e.stopPropagation();
});

$('body').click(function() {
  closeSecondaryNavigation();
});

// Close secondary navigation when pressing 'esc'
$(document).on('keyup', function(evt) {
  if (evt.keyCode == 27) {
    closeSecondaryNavigation();
  }
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Footer form
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('.js-toggle-footer-form').click(function(e) {
  var footerFormTarget = $(this).data('target-form');

  $(this)
    .addClass('is-active')
    .siblings()
    .removeClass('is-active');

  $('.footer__form-holder__item--' + footerFormTarget)
    .removeClass('is-hidden')
    .siblings()
    .addClass('is-hidden');

  e.preventDefault();
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Cart
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('.cart .control.checkbox input').change(function() {
  $('.cart__options__row .control').removeClass('is-highlighted');

  if ($('.cart .control.checkbox input').is(':checked')) {
    $('.cart__options .button-list .button.js-toggle-disabled').removeClass('is-disabled');
  } else {
    $('.cart__options .button-list .button.js-toggle-disabled').addClass('is-disabled');
  }
});

$('.cart__options .button-list .button.js-toggle-disabled').click(function(e) {
  if ($(this).hasClass('is-disabled')) {
    $('.cart__options__row .control').addClass('is-highlighted');
    e.preventDefault();
  }
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Tooltip
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

tippy('.has-tooltip', {
  arrow: true,
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Password reset button
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

$('.account-form .js-password-reset').on('click', function(e) {
  e.preventDefault();
  $('.account-form:not(.js-password-reset-form)').addClass('is-hidden');
  $('.account-form.js-password-reset-form').removeClass('is-hidden');
});

// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// Get correct provinces for each country
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---

const countryProvinceSelector = () => {
  const forms = document.querySelectorAll('.account-form__content');

  if (forms.length > 0) {
    for (let form of forms) {
      let countrySelector = form.querySelector('select.country-selector');
      let provinceSelector = form.querySelector('select.province-selector');

      if (countrySelector === undefined || provinceSelector === undefined) {
        return false;
      }

      countrySelector.addEventListener('change', e => {
        e.preventDefault();

        let selected = countrySelector.options[countrySelector.selectedIndex];
        let provinces = JSON.parse(selected.dataset.provinces);

        provinceSelector.innerHTML = '';
        provinceSelector.parentElement.parentElement.classList.add('is-hidden');

        if (provinces.length > 0) {
          provinceSelector.parentElement.parentElement.classList.remove('is-hidden');

          for (let province of provinces) {
            let element = `<option value="${province[0]}">${province[1]}</option>`;
            provinceSelector.insertAdjacentHTML('beforeend', element);
          }
        } else {
          let element = `<option value=""></option>`;
          provinceSelector.insertAdjacentHTML('beforeend', element);
        }

        //countrySelector.options[countrySelector.selectedIndex].text;
      });
    }
  }
};

countryProvinceSelector();
